'use client';

import { Login } from '@web/components/account/Login';
import { AppLayout } from '@web/components/AppLayout';

export default function LoginPage() {
  return (
    <AppLayout>
      <Login />
    </AppLayout>
  );
}
